import React from "react";
import Container from "../../../Components/Container";
import SavingImage from "./assets/SavingsImage@2x.png";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
import styled from "styled-components";
const SavingsStyles = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  z-index: 3;
  font-size: 48px;

  color: white;
  span {
    margin-top: 100px;
    margin-left: 40px;
  }
`;
const Saving = () => {
  return (
    <Container>
      <BGImageDisplay bgimage={SavingImage} />
      <SavingsStyles>
        <span> WHY SOLAR?</span>
      </SavingsStyles>
    </Container>
  );
};

export default Saving;
